import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import Pagination from "../../components/shared/Pagination"
import Btn from "../../components/shared/button/Btn"
import { getLookingLoadAdmin } from "../../features/admin5/admin5Slice"
import InputText from "../../components/shared/input/new/InputText"
import AdminYukAriyorumContainer from "../../components/adminContainers/AdminYukAriyorumContainer"
import InputSelectCity from "../../components/shared/input/new/InputSelectCity"

const Container = styled.div`
    .wrapper {
        width: 100%;
        padding: 30px;

        .top-container {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            gap: 30px;
            margin-bottom: 30px;
        }
        .content{
            .list{
                display: flex;
                flex-direction: column;
                gap: 20px;
            }
            .titles {
              width: 100%;
              display: grid;
              grid-template-columns:  repeat(9, 1fr);
              padding-inline: 10px;
              margin-bottom: 20px;
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
                p{
                  text-align: center;
                }
            }
        }
    }
`

const titles = ["Telefon", "İsim", "Başlangıç Noktası", "Bitiş Noktası", "Yükün Taşınabileceği Tarih", "Parsiyel", "Komple", "Durum", "Mesaj Gönderildi Mi?"]

const AdminYukAriyorum = () => {

    const dispatch = useDispatch()
    const {lookingLoadList, lookingLoadListCount} = useSelector(state => state.admin5)
    const itemsPerPage = 20;
    const totalPages = Math.ceil(lookingLoadListCount / itemsPerPage);

    const [currentPage, setCurrentPage] = useState(1)
    const [name, setName] = useState("")
    const [startPoint, setStartPoint] = useState(null)
    const [endPoint, setEndPoint] = useState(null)

    useEffect(() => {
        dispatch(getLookingLoadAdmin({page: currentPage, name: name, startPoint: startPoint?.value, endPoint: endPoint?.value}))
    }, [currentPage, name, startPoint, endPoint])

    const handleClear = () => {
        setName("")
        setStartPoint(null)
        setEndPoint(null)
    }

  return (
    <Container>
            <PageTopTitle title={"Yük Arıyorum"}/>
        <div className="wrapper">
            <div className="top-container">
                <InputText data={name} setData={(e) => setName(e.target.value)} labelText={"İsim"} name={"name"}/>
                <InputSelectCity data={startPoint?.value} setData={setStartPoint} labelText={"Başlangıç Noktası"} name={"startPoint"} />
                <InputSelectCity data={endPoint?.location} setData={setEndPoint} labelText={"Bitiş Noktası"} name={"endPoint"} />
                <Btn bgColor="transparent" color="#E85446" handleClick={handleClear} width={"120px"} >Temizle</Btn>
            </div>
            <div className="content">
                <div className="titles">
                    {titles.map((item) => (
                    <p>{item}</p>
                    ))}
                </div>
                <div className="list">
                    {lookingLoadList.map((item) => (
                        <AdminYukAriyorumContainer data={item}/>
                    ))}
                </div>
                <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>

            </div>
        </div>
    </Container>
  )
}

export default AdminYukAriyorum